"use client";

import { useEffect, useState } from "react";
import DonationModal from "@/components/DonationModal";
import { DONATE_OPEN_EVENT, stripDonateHash } from "@/lib/donate";

export default function DonateHost() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    stripDonateHash();
    function openModal() {
      stripDonateHash();
      setOpen(true);
    }
    window.addEventListener(DONATE_OPEN_EVENT, openModal);
    return () => window.removeEventListener(DONATE_OPEN_EVENT, openModal);
  }, []);

  if (!open) return null;

  return (
    <DonationModal
      onClose={() => {
        setOpen(false);
        stripDonateHash();
      }}
    />
  );
}
